import {useLocation} from 'react-router-dom'
import {canonicalPath, landingPages} from '../Seo/siteContent'
import './LandingContent.scss'

export default function LandingContent() {
    const path = canonicalPath(useLocation().pathname)
    const page = landingPages[path]
    const routeLinks = [
    {
        "href": "/routes/voronezh-moskva/",
        "label": "Воронеж — Москва и обратно",
        "cities": [
            "/voronezh/"
        ],
        "home": true
    },
    {
        "href": "/routes/rossosh-moskva/",
        "label": "Россошь — Москва и обратно",
        "cities": [
            "/rossosh/"
        ],
        "home": true
    },
    {
        "href": "/routes/boguchar-moskva/",
        "label": "Богучар — Москва и обратно",
        "cities": [
            "/boguchar/"
        ],
        "home": true
    },
    {
        "href": "/routes/kpp-bugaevka-moskva/",
        "label": "КПП Бугаевка — Москва и обратно",
        "cities": [
            "/bugaevka/"
        ],
        "home": true
    },
    {
        "href": "/routes/valuyki-moskva/",
        "label": "Валуйки — Москва и обратно",
        "cities": [
            "/valuyki/"
        ],
        "home": true
    },
    {
        "href": "/routes/voronezh-boguchar/",
        "label": "Воронеж — Богучар и обратно",
        "cities": [
            "/voronezh/",
            "/boguchar/"
        ],
        "home": true
    },
    {
        "href": "/routes/voronezh-sheremetyevo/",
        "label": "Воронеж — аэропорт Шереметьево и обратно",
        "cities": [
            "/voronezh/"
        ],
        "home": true
    },
    {
        "href": "/routes/kpp-rovenki-moskva/",
        "label": "КПП Ровеньки — Москва и обратно",
        "cities": [
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/kpp-bugaevka-sheremetyevo/",
        "label": "КПП Бугаевка — аэропорт Шереметьево и обратно",
        "cities": [
            "/bugaevka/"
        ],
        "home": false
    },
    {
        "href": "/routes/rossosh-voronezh/",
        "label": "Россошь — Воронеж и обратно",
        "cities": [
            "/rossosh/",
            "/voronezh/"
        ],
        "home": false
    },
    {
        "href": "/routes/boguchar-rossosh/",
        "label": "Богучар — Россошь и обратно",
        "cities": [
            "/boguchar/",
            "/rossosh/"
        ],
        "home": false
    },
    {
        "href": "/routes/rossosh-kpp-bugaevka/",
        "label": "Россошь — КПП Бугаевка и обратно",
        "cities": [
            "/rossosh/",
            "/bugaevka/"
        ],
        "home": false
    },
    {
        "href": "/routes/kpp-bugaevka-millerovo/",
        "label": "КПП Бугаевка — Миллерово и обратно",
        "cities": [
            "/bugaevka/",
            "/millerovo/"
        ],
        "home": false
    },
    {
        "href": "/routes/kpp-bugaevka-boguchar/",
        "label": "КПП Бугаевка — Богучар и обратно",
        "cities": [
            "/bugaevka/",
            "/boguchar/"
        ],
        "home": false
    },
    {
        "href": "/routes/rossosh-lugansk/",
        "label": "Россошь — Луганск и обратно",
        "cities": [
            "/rossosh/"
        ],
        "home": false
    },
    {
        "href": "/routes/millerovo-lugansk/",
        "label": "Миллерово — Луганск и обратно",
        "cities": [
            "/millerovo/"
        ],
        "home": false
    },
    {
        "href": "/routes/rossosh-rostov-na-donu/",
        "label": "Россошь — Ростов-на-Дону и обратно",
        "cities": [
            "/rossosh/"
        ],
        "home": false
    },
    {
        "href": "/routes/valuyki-belgorod/",
        "label": "Валуйки — Белгород и обратно",
        "cities": [
            "/valuyki/"
        ],
        "home": false
    },
    {
        "href": "/routes/rossosh-rovenki/",
        "label": "Россошь — посёлок Ровеньки и обратно",
        "cities": [
            "/rossosh/",
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/rossosh-kpp-rovenki/",
        "label": "Россошь — КПП Ровеньки и обратно",
        "cities": [
            "/rossosh/",
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/voronezh-vnukovo/",
        "label": "Воронеж — аэропорт Внуково и обратно",
        "cities": [
            "/voronezh/"
        ],
        "home": false
    },
    {
        "href": "/routes/voronezh-domodedovo/",
        "label": "Воронеж — аэропорт Домодедово и обратно",
        "cities": [
            "/voronezh/"
        ],
        "home": false
    },
    {
        "href": "/routes/voronezh-sankt-peterburg/",
        "label": "Воронеж — Санкт-Петербург и обратно",
        "cities": [
            "/voronezh/"
        ],
        "home": false
    },
    {
        "href": "/routes/rossosh-sheremetyevo/",
        "label": "Россошь — аэропорт Шереметьево и обратно",
        "cities": [
            "/rossosh/"
        ],
        "home": false
    },
    {
        "href": "/routes/rossosh-vnukovo/",
        "label": "Россошь — аэропорт Внуково и обратно",
        "cities": [
            "/rossosh/"
        ],
        "home": false
    },
    {
        "href": "/routes/rossosh-domodedovo/",
        "label": "Россошь — аэропорт Домодедово и обратно",
        "cities": [
            "/rossosh/"
        ],
        "home": false
    },
    {
        "href": "/routes/rossosh-sankt-peterburg/",
        "label": "Россошь — Санкт-Петербург и обратно",
        "cities": [
            "/rossosh/"
        ],
        "home": false
    },
    {
        "href": "/routes/boguchar-sheremetyevo/",
        "label": "Богучар — аэропорт Шереметьево и обратно",
        "cities": [
            "/boguchar/"
        ],
        "home": false
    },
    {
        "href": "/routes/boguchar-vnukovo/",
        "label": "Богучар — аэропорт Внуково и обратно",
        "cities": [
            "/boguchar/"
        ],
        "home": false
    },
    {
        "href": "/routes/boguchar-domodedovo/",
        "label": "Богучар — аэропорт Домодедово и обратно",
        "cities": [
            "/boguchar/"
        ],
        "home": false
    },
    {
        "href": "/routes/boguchar-sankt-peterburg/",
        "label": "Богучар — Санкт-Петербург и обратно",
        "cities": [
            "/boguchar/"
        ],
        "home": false
    },
    {
        "href": "/routes/millerovo-moskva/",
        "label": "Миллерово — Москва и обратно",
        "cities": [
            "/millerovo/"
        ],
        "home": false
    },
    {
        "href": "/routes/millerovo-sheremetyevo/",
        "label": "Миллерово — аэропорт Шереметьево и обратно",
        "cities": [
            "/millerovo/"
        ],
        "home": false
    },
    {
        "href": "/routes/millerovo-vnukovo/",
        "label": "Миллерово — аэропорт Внуково и обратно",
        "cities": [
            "/millerovo/"
        ],
        "home": false
    },
    {
        "href": "/routes/millerovo-domodedovo/",
        "label": "Миллерово — аэропорт Домодедово и обратно",
        "cities": [
            "/millerovo/"
        ],
        "home": false
    },
    {
        "href": "/routes/millerovo-sankt-peterburg/",
        "label": "Миллерово — Санкт-Петербург и обратно",
        "cities": [
            "/millerovo/"
        ],
        "home": false
    },
    {
        "href": "/routes/valuyki-sheremetyevo/",
        "label": "Валуйки — аэропорт Шереметьево и обратно",
        "cities": [
            "/valuyki/"
        ],
        "home": false
    },
    {
        "href": "/routes/valuyki-vnukovo/",
        "label": "Валуйки — аэропорт Внуково и обратно",
        "cities": [
            "/valuyki/"
        ],
        "home": false
    },
    {
        "href": "/routes/valuyki-domodedovo/",
        "label": "Валуйки — аэропорт Домодедово и обратно",
        "cities": [
            "/valuyki/"
        ],
        "home": false
    },
    {
        "href": "/routes/valuyki-sankt-peterburg/",
        "label": "Валуйки — Санкт-Петербург и обратно",
        "cities": [
            "/valuyki/"
        ],
        "home": false
    },
    {
        "href": "/routes/rovenki-moskva/",
        "label": "посёлок Ровеньки — Москва и обратно",
        "cities": [
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/rovenki-sheremetyevo/",
        "label": "посёлок Ровеньки — аэропорт Шереметьево и обратно",
        "cities": [
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/rovenki-vnukovo/",
        "label": "посёлок Ровеньки — аэропорт Внуково и обратно",
        "cities": [
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/rovenki-domodedovo/",
        "label": "посёлок Ровеньки — аэропорт Домодедово и обратно",
        "cities": [
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/rovenki-sankt-peterburg/",
        "label": "посёлок Ровеньки — Санкт-Петербург и обратно",
        "cities": [
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/kpp-rovenki-sheremetyevo/",
        "label": "КПП Ровеньки — аэропорт Шереметьево и обратно",
        "cities": [
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/kpp-rovenki-vnukovo/",
        "label": "КПП Ровеньки — аэропорт Внуково и обратно",
        "cities": [
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/kpp-rovenki-domodedovo/",
        "label": "КПП Ровеньки — аэропорт Домодедово и обратно",
        "cities": [
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/kpp-rovenki-sankt-peterburg/",
        "label": "КПП Ровеньки — Санкт-Петербург и обратно",
        "cities": [
            "/rovenki/"
        ],
        "home": false
    },
    {
        "href": "/routes/kpp-bugaevka-vnukovo/",
        "label": "КПП Бугаевка — аэропорт Внуково и обратно",
        "cities": [
            "/bugaevka/"
        ],
        "home": false
    },
    {
        "href": "/routes/kpp-bugaevka-domodedovo/",
        "label": "КПП Бугаевка — аэропорт Домодедово и обратно",
        "cities": [
            "/bugaevka/"
        ],
        "home": false
    },
    {
        "href": "/routes/kpp-bugaevka-sankt-peterburg/",
        "label": "КПП Бугаевка — Санкт-Петербург и обратно",
        "cities": [
            "/bugaevka/"
        ],
        "home": false
    }
].filter(route => path === '/' ? route.home : route.cities.includes(path))
    if (!page) return null
    return <section className="LandingContent" aria-labelledby="trip-planning-title">
        <div className="LandingContent__intro">
            <p className="LandingContent__eyebrow">Планирование поездки</p>
            <h2 id="trip-planning-title">{page.heading}</h2>
            <p>{page.intro}</p>
        </div>
        <div className="LandingContent__cards">
            {page.sections.map(section => <article key={section.heading}>
                <h3>{section.heading}</h3>
                <p>{section.text}</p>
                        {section.link && <p><a href={section.link.href}>{section.link.label}</a></p>}
            </article>)}
        </div>
        {routeLinks.length > 0 && <nav className="LandingContent__directions" aria-labelledby="route-directions-title">
            <h2 id="route-directions-title">Междугородние маршруты</h2>
            <p>Откройте нужное направление, сравните классы и уточните детали поездки.</p>
            <ul>{routeLinks.map(route => <li key={route.href}><a href={route.href}><span>{route.label}</span><small>Калькулятор стоимости и условия поездки</small><span className="LandingContent__arrow" aria-hidden="true">↗</span></a></li>)}</ul>
        </nav>}
        <p className="LandingContent__catalog"><a href="/routes/">Все 52 маршрута Флики — города, аэропорты и КПП</a></p>
        <nav className="LandingContent__directions" aria-labelledby="directions-title">
            <h2 id="directions-title">{path === '/' ? 'Города и пункты отправления' : 'Другие направления Флики'}</h2>
            <p>{path === '/' ? 'Выберите раздел, чтобы уточнить детали поездки из нужного города или от КПП.' : 'Если поездка начинается в другом месте, перейдите в соответствующий раздел.'}</p>
            <ul>{page.related.map(href => <li key={href}>
                <a href={href}><span>{landingPages[href].label}</span>{landingPages[href].region && <small>{landingPages[href].region}</small>}<span className="LandingContent__arrow" aria-hidden="true">↗</span></a>
            </li>)}</ul>
        </nav>
    </section>
}
